// extracted by mini-css-extract-plugin
export default {"root":"tag_root__DfNm4","new":"tag_new__eXjBQ","hot":"tag_hot__TOrr6"};